import React from 'react';
import Card from './Cards';  // Make sure to import the Card component

class CardGridView extends React.Component {
  render() {
    const { data } = this.props;

    if (!data || data.length === 0) {
      return (
        <div className="service-card-grid-view placeholder">
          <p>Loading services...</p>
        </div>
      );
    }

    return (
      <div className="service-card-grid-view">
        {data.map((cardData, index) => (
          <Card data={cardData} key={`card-id-${index}`} />
        ))}
      </div>
    );
  }
}


export default CardGridView;


